var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7829 13.4155L13.0614 1.691C12.4638 0.648234 11.3499 0 10.1542 0C8.95897 0 7.84531 0.648022 7.24705 1.69058L0.448142 13.5496C-0.149486 14.5924 -0.149276 15.888 0.448142 16.9297C1.04598 17.9725 2.15986 18.6207 3.35553 18.6207H16.9557C16.9651 18.6207 16.9748 18.6207 16.9847 18.6201C18.8228 18.6057 20.3135 17.0944 20.3135 15.24C20.3135 14.5892 20.1303 13.9604 19.7829 13.4155ZM10.1568 4.90824C11.2082 4.90824 11.4645 5.70429 11.4 6.16024L10.7691 11.1011C10.7481 11.5479 10.4032 11.7178 10.1568 11.7178C9.88065 11.7178 9.56859 11.5712 9.54441 11.1011L8.91355 6.16024C8.849 5.69116 9.11185 4.90824 10.1568 4.90824ZM11.0656 14.6019C10.8286 14.8431 10.4964 14.9831 10.1568 14.9831C9.81672 14.9831 9.48468 14.8431 9.24517 14.6019C9.00587 14.3607 8.86939 14.0263 8.86939 13.6839C8.86939 13.3442 9.00587 13.0098 9.24517 12.7686C9.48468 12.5274 9.81672 12.3899 10.1568 12.3899C10.4964 12.3899 10.8286 12.5272 11.0656 12.7686C11.3074 13.0098 11.4441 13.3442 11.4441 13.6839C11.4441 14.0263 11.3076 14.3607 11.0656 14.6019Z",
    fill: "url(#paint0_linear_160_863)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_863",
    x1: 10.1567,
    y1: 0,
    x2: 10.1567,
    y2: 18.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00",
    stopOpacity: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.82a7bfd9d1f5d7e13b15c89febf1439b.svg";
export { ForwardRef as ReactComponent };